export default "__VITE_ASSET__DkOFc5D$__"